import type { GatewayConfig } from '@/core/api'

import type { GatewayRuntimePorts } from './interfaces/gatewayRuntimePorts.interface'
import type { GatewayUserSettings } from './interfaces/gatewayUserSettings.interface'
import { isLocalGatewayConfigurationMode } from './isLocalGatewayConfigurationMode'

const usesGatewayBrowserOrigin = (): boolean =>
  typeof window !== 'undefined' && !process.env.NEXT_PUBLIC_GATEWAY_URL?.trim()

const resolveLocalWsPort = (config: GatewayConfig, userSettings?: GatewayUserSettings): string | undefined => {
  if (userSettings?.useCustom) {
    return userSettings.wsPort?.trim() || userSettings.httpPort?.trim() || config.port
  }

  return config.port
}

const resolveLocalMcpPort = (config: GatewayConfig, userSettings?: GatewayUserSettings): string | undefined => {
  if (userSettings?.useCustom) {
    return userSettings.mcpPort?.trim() || userSettings.httpPort?.trim() || config.port
  }

  return config.port
}

export function resolveGatewayRuntimePorts(
  config: GatewayConfig,
  apiPorts: { websocketPort: string; mcpPort: string },
  userSettings?: GatewayUserSettings
): GatewayRuntimePorts {
  const useBrowserOrigin = usesGatewayBrowserOrigin()
  const useCustomUserPorts = Boolean(userSettings?.useCustom && isLocalGatewayConfigurationMode())

  if (useBrowserOrigin || useCustomUserPorts) {
    return {
      gatewayPath: config.host,
      gatewayWsPort: resolveLocalWsPort(config, userSettings),
      gatewayMcpPort: resolveLocalMcpPort(config, userSettings),
      isSecured: config.isSecured,
    }
  }

  return {
    gatewayPath: config.host,
    gatewayWsPort: apiPorts.websocketPort,
    gatewayMcpPort: apiPorts.mcpPort,
    isSecured: config.isSecured,
  }
}
